export default function ComparisonTable() {
  const rows = [
    { feature: 'Decision Speed', manual: 'Slow — scattered data', oopbuy: 'Fast — centralized view' },
    { feature: 'Error Rate', manual: 'High — manual entry risk', oopbuy: 'Low — validated system' },
    { feature: 'Organization', manual: 'Poor — fragmented links', oopbuy: 'Structured — single dashboard' },
    { feature: 'Tracking Ability', manual: 'Hard — no central log', oopbuy: 'Easy — real-time updates' },
    { feature: 'Scalability', manual: 'Limited — manual overhead', oopbuy: 'High — handles bulk orders' },
    { feature: 'Price Discovery', manual: 'Time-consuming browsing', oopbuy: 'Instant comparison across sellers' },
    { feature: 'Learning Curve', manual: 'Varies by platform', oopbuy: 'Simple template-based system' },
    { feature: 'Multi-Category Support', manual: 'Platform-dependent', oopbuy: '14 categories unified' },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10">
          <div>
            <p className="text-xs md:text-sm text-foreground-500 tracking-wider mb-2 whitespace-nowrap">
              Compare Options
            </p>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              Why Choose OOPBuy Spreadsheet
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md leading-relaxed">
            See how the OOPBuy Spreadsheet system outperforms traditional manual shopping across every key metric that matters for efficient purchasing.
          </p>
        </div>

        <div className="overflow-x-auto rounded-2xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-accent-400">
                <th className="text-left px-5 py-4 text-foreground-950 font-semibold text-sm rounded-tl-2xl whitespace-nowrap">
                  Feature
                </th>
                <th className="text-left px-5 py-4 text-foreground-950 font-semibold text-sm whitespace-nowrap">
                  Manual Shopping
                </th>
                <th className="text-left px-5 py-4 text-foreground-950 font-semibold text-sm rounded-tr-2xl whitespace-nowrap">
                  OOPBuy Spreadsheet
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr
                  key={row.feature}
                  className={`border-t border-background-200/50 ${i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}
                >
                  <td className="px-5 py-4 text-foreground-800 font-medium whitespace-nowrap">{row.feature}</td>
                  <td className="px-5 py-4 text-foreground-500">{row.manual}</td>
                  <td className="px-5 py-4 text-primary-600 font-medium">{row.oopbuy}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}